import { useState, useEffect } from 'react';

import dayjs from 'dayjs';

export default function GroupProductCountdown({ data }) {
  const [time, setTime] = useState({
    Day: '00',
    Hour: '00',
    Minute: '00',
    Second: '00',
  });

  useEffect(() => {
    let timer = null;

    const refreshTime = () => {
      const targetDate = data.groupActivityProductVO.groupEndTime;
      const nowTime = dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).toDate();
      const end = dayjs(targetDate).toDate();
      const sec = dayjs(end).diff(dayjs(nowTime), 'second');

      if (sec < 0) {
        clearInterval(timer);
        setTime({
          Day: '00',
          Hour: '00',
          Minute: '00',
          Second: '00',
        });
        return;
      }

      const days = Math.floor(sec / (60 * 60 * 24));
      const hours = Math.floor((sec - days * 24 * 60 * 60) / 3600);
      const minutes = Math.floor((sec - days * 24 * 60 * 60 - hours * 3600) / 60);
      const seconds = Math.floor(sec - days * 24 * 60 * 60 - hours * 3600 - minutes * 60);

      setTime({
        Day: days.toString().padStart(2, '0'),
        Hour: hours.toString().padStart(2, '0'),
        Minute: minutes.toString().padStart(2, '0'),
        Second: seconds.toString().padStart(2, '0'),
      });
    };

    if (data.isGroupProduct && data?.groupActivityProductVO?.groupEndTime) {
      timer = setInterval(refreshTime, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [data]);

  return (
    data.isGroupProduct && (
      <section className="w-[355px] h-[48px] flex items-center justify-between rounded-[8px] bg-[url('https://static.szlcsc.com/ecp/assets/app/product-detail/lt.png')] bg-cover bg-no-repeat">
        <div className="ml-[60px] font-bold">
          <span className="text-[12px]">￥</span>
          <span className="text-[14px]">{data.groupActivityProductVO.groupPrice}</span>
        </div>
        <div className="mr-[5px] flex flex-col items-center text-[12px]">
          <span>距结束还剩</span>
          <div className="mt-[4px] text-[#ff4960]">
            <span>{time.Day}天</span>
            <span className="w-[16px] h-[16px] bg-white leading-[16px] rounded mx-[2px] px-[2px]">{time.Hour}</span>
            <span className="text-white">:</span>
            <span className="w-[16px] h-[16px] bg-white leading-[16px] rounded mx-[2px] px-[2px]">{time.Minute}</span>
            <span className="text-white">:</span>
            <span className="w-[16px] h-[16px] bg-white leading-[16px] rounded mx-[2px] px-[2px]">{time.Second}</span>
          </div>
        </div>
      </section>
    )
  );
}
